export const SITE_LOADER_TOGGLE = 'SITE_LOADER_TOGGLE';
export const SITE_LOADER_HIDE = 'SITE_LOADER_HIDE';
